export default __webpack_public_path__ + "assets/icon-schedule.cadd39e0.webp";